import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// import drizzle functions and contract artifact
import { Drizzle, generateStore } from "@drizzle/store";
import MyStringStore from "./contracts/MyStringStore.json";
import VaultSystem from "./contracts/VaultSystem.json";
import GeneralToken from "./contracts/GeneralToken.json";
import ClaimPriorityDate from "./contracts/ClaimPriorityDate.json";

// let drizzle know what contracts we want and how to access our test blockchain
const options = {
  contracts: [MyStringStore, VaultSystem, ClaimPriorityDate], 
  web3: {
    fallback: {
      type: "ws",
      url: "ws://127.0.0.1:9545",
    },
  },
};

// setup the drizzle store and drizzle
console.log("Setting Up Drizzle Store")
const drizzle = new Drizzle(options);
console.log("Drizzle Store Done")
ReactDOM.render(<App drizzle={drizzle} />, document.getElementById('root'));